import React, {useId} from 'react';

export default function BotanicalLeaf() {
    const gradientId = `botanical-leaf-${useId().replace(/:/g, '')}`;
    return <svg viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
        <defs>
            <linearGradient id={gradientId} x1="12" y1="36" x2="36" y2="8" gradientUnits="userSpaceOnUse">
                <stop stopColor="#244b35"/>
                <stop offset=".48" stopColor="#568343"/>
                <stop offset="1" stopColor="#a0b866"/>
            </linearGradient>
        </defs>
        <path d="M12 36C3 21 17 9 39 5c-1 8 3 16-4 25-6 8-15 11-23 6Z" fill={`url(#${gradientId})`} stroke="#46683b" strokeWidth=".6"/>
        <path d="M12 36C21 22 30 14 39 5c-1 8 3 16-4 25-6 8-15 11-23 6Z" fill="#173e2a" opacity=".2"/>
        <path d="M7 43C14 30 25 18 36 9" stroke="#d5dca1" strokeWidth="1.3" strokeLinecap="round"/>
        <g stroke="#c1d08a" strokeWidth=".7" strokeLinecap="round" opacity=".8">
            <path d="m15 30-3-10m8 4-1-10m7 4 1-7m-9 16 11 1m-6-7 12 0m-6-6 7-1"/>
        </g>
        <path d="M7 43 12 35" stroke="#637840" strokeWidth="1.6" strokeLinecap="round"/>
    </svg>;
}
